import { BannerNotification } from '@hologram-dimension/banner-notification';
import { Panel } from '@hologram-dimension/panel';
import { type ReactNode } from 'react';

export type MessageType = 'error' | 'success';
export interface Message {
  message: string;
  messageType: MessageType;
}
interface FormPanelProps {
  children?: ReactNode;
  footer?: ReactNode;
  message?: string;
  messageType?: MessageType;
  title?: string;
}

const FormPanel = ({
  children,
  footer,
  message,
  messageType,
  title = 'Form panel title',
}: FormPanelProps) => {
  const messageToShow = message?.trim();
  return (
    <Panel className="form-panel" header={title} footer={footer} footerVariant="alternative">
      {messageToShow && (
        <BannerNotification
          variant={messageType}
          className="form-panel__message"
          aria-live="assertive"
        >
          {messageToShow}
        </BannerNotification>
      )}
      {children}
    </Panel>
  );
};

export default FormPanel;
